import type { BlogPost } from "./blog";

export const BLOG_LIFESTYLE_PART2: BlogPost[] = [
  {
    "slug": "restorany-zhivaya-muzyka-peterburg-top",
    "title": "Рестораны с живой музыкой в Петербурге: топ мест",
    "metaTitle": "Рестораны с живой музыкой в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Топ ресторанов с живой музыкой в Санкт-Петербурге: где слушать живой звук за ужином в 2026.",
    "keywords": "рестораны живая музыка петербург, рестораны живая музыка спб, живая музыка ужин петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Живая музыка в ресторане — это опыт, который невозможно воссоздать через динамики. Петербург богат музыкальными традициями, и несколько ресторанов города делают живой звук частью своей ДНК.",
    "sections": [
      {
        "heading": "Что даёт живая музыка в ресторане",
        "body": "Живой звук создаёт уникальную атмосферу — каждый вечер немного другую. Музыкант реагирует на зал, меняет темп и стиль. Это принципиально отличается от плейлиста: живой исполнитель — это собеседник для настроения зала. Рестораны с регулярной живой музыкой создают свою аудиторию — людей, которые приходят снова.",
        "list": [
          "Уникальность: каждый вечер чуть другой",
          "Контакт: исполнитель чувствует зал",
          "Формат фона: джаз или акустика не мешают разговору",
          "Причина прийти снова: конкретный музыкант"
        ]
      },
      {
        "heading": "«Паруса на крыше» — живая музыка с видом",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) регулярно приглашает живых музыкантов — преимущественно джазовые коллективы и авторских исполнителей. Расписание публикуется в афише. Сочетание: 300° панорама Петербурга + живая музыка + авторская кухня = вечер, который сложно забыть. Рейтинг 5,0, работает с 2009 года.",
        "highlight": "Уточняйте расписание живой музыки при бронировании: +7 (812) 991-10-90. Пятница и суббота — наиболее частые дни живого звука."
      },
      {
        "heading": "Советы по выбору",
        "body": "Ищите рестораны с постоянным расписанием (не разовые события). Уточняйте жанр — джаз, вокал, акустика, кавер-группа — под свои предпочтения. Читайте об <a href='/afisha' class='underline text-accent'>актуальной афише «Парусов»</a>."
      }
    ],
    "cta": { "text": "Забронировать вечер с живой музыкой", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "dzhaz-vechera-restorany-spb",
    "title": "Джаз-вечера в ресторанах СПб: где слушать джаз",
    "metaTitle": "Джаз-вечера в ресторанах СПб 2026 | Паруса на крыше",
    "metaDescription": "Где слушать джаз в ресторанах Санкт-Петербурга: джаз-вечера, живые концерты, уютные места.",
    "keywords": "джаз вечера рестораны спб, джаз ресторан петербург, слушать джаз петербург ресторан",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Джаз в Петербурге — не просто музыкальный жанр, это городская традиция. Клуб «Джаз Филармония» работает с 1979 года. Но наслаждаться джазом можно и за ужином — в ресторанах, где живой звук — часть концепции.",
    "sections": [
      {
        "heading": "Джаз в ресторане vs джаз-клуб",
        "body": "Джаз-клуб — это место, куда идут специально за музыкой. Ресторан с джазом — это место, где вы наслаждаетесь едой, а музыка создаёт идеальный фон. Два разных опыта. Для романтического ужина, корпоратива или деловой встречи — ресторан с живым джазом работает лучше: вы не обязаны молчать и слушать, музыка дополняет, а не доминирует.",
        "list": [
          "Джаз-клуб: приходят за музыкой",
          "Ресторан с джазом: музыка создаёт атмосферу",
          "Для ужина: ресторан — оптимальный формат",
          "Громкость: фоновый джаз, не концертный"
        ]
      },
      {
        "heading": "Джаз в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5) приглашают джазовые коллективы по расписанию. Авторская кухня, панорама Петербурга, живой джаз — сочетание, создающее «тот самый вечер». Читайте актуальную <a href='/afisha' class='underline text-accent'>афишу ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать джазовый вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "gde-poslushat-zhivuyu-muzyku-peterburg",
    "title": "Где послушать живую музыку в Петербурге",
    "metaTitle": "Где послушать живую музыку в Петербурге 2026 | Паруса",
    "metaDescription": "Где слушать живую музыку в Санкт-Петербурге: рестораны, клубы, площадки. Путеводитель по живому звуку.",
    "keywords": "где послушать живую музыку петербург, живая музыка петербург 2026, концерт живая музыка спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Живая музыка в Петербурге — везде. Филармония, театры, джаз-клубы, рестораны. Разберём форматы, чтобы найти подходящий под ваш вечер.",
    "sections": [
      {
        "heading": "Форматы живой музыки в городе",
        "body": "Академическая: Филармония (два зала), консерватория, Мариинский. Требует планирования и формального настроя. Джаз: Джаз Филармония, Джем-клуб, Эдинбург. Более камерно. Рестораны с живой музыкой: интегрированы в ужин, не требуют специального похода. Стрит-музыканты: Невский, летом — везде.",
        "list": [
          "Филармония: академический формат, лучший звук",
          "Джаз-клубы: неформально, живо",
          "Рестораны: музыка как часть вечера",
          "Лето: музыканты на улицах центра"
        ]
      },
      {
        "heading": "Рестораны с живой музыкой как лучший формат для ужина",
        "body": "Если ваша цель — приятный вечер, а не концерт, — ресторан с живой музыкой оптимален. «Паруса на крыше» (ул. Марата, 5, 6 этаж) — живая музыка по расписанию, авторская кухня, вид на Петербург. Рейтинг 5,0. Телефон: +7 (812) 991-10-90. Читайте <a href='/afisha' class='underline text-accent'>афишу</a>."
      }
    ],
    "cta": { "text": "Забронировать вечер с музыкой", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "restorany-zhivym-vokalom-spb",
    "title": "Рестораны с живым вокалом в СПб: где найти",
    "metaTitle": "Рестораны с живым вокалом СПб 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с живым вокалом в Санкт-Петербурге: где слушать живые голоса за ужином.",
    "keywords": "рестораны живой вокал спб, живой вокал ресторан петербург, певица в ресторане спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Живой вокал в ресторане — особый формат. Голос трогает эмоционально иначе, чем инструмент. Хороший вокалист превращает ужин в эмоциональное переживание.",
    "sections": [
      {
        "heading": "Какой вокал подходит для ресторана",
        "body": "Джазовый вокал: элегантно, обволакивает, не отвлекает от разговора. Авторская песня: более личное, создаёт особую связь с залом. Эстрада или поп-кавер: зависит от исполнителя — может быть прекрасно или навязчиво. Для романтического ужина или корпоратива — джазовый вокал работает лучше всего.",
        "list": [
          "Джазовый вокал: универсальный выбор для ужина",
          "Авторская песня: камерно, личностно",
          "Классический романс: торжественно",
          "Поп-кавер: зависит от репертуара"
        ]
      },
      {
        "heading": "Вокал в «Парусах»",
        "body": "В программе «Парусов» (ул. Марата, 5) периодически выступают вокалисты. Следите за расписанием в афише или уточняйте при бронировании +7 (812) 991-10-90. Читайте <a href='/afisha' class='underline text-accent'>актуальную афишу</a>."
      }
    ],
    "cta": { "text": "Забронировать вечер с вокалом", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "dzhaz-peterburg-luchshie-mesta",
    "title": "Джаз в Петербурге: лучшие места и площадки",
    "metaTitle": "Джаз в Петербурге — лучшие места 2026 | Паруса на крыше",
    "metaDescription": "Лучшие места для джаза в Санкт-Петербурге: клубы, рестораны, площадки. Путеводитель по джазу.",
    "keywords": "джаз петербург лучшие места, джаз клуб петербург, джаз спб где послушать",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Петербург — один из главных джазовых городов России. Традиция восходит к 1960-м, когда советский джаз нашёл здесь особую аудиторию. Разберём, где слушать джаз сегодня.",
    "sections": [
      {
        "heading": "История джаза в Петербурге",
        "body": "Джазовая история Петербурга началась в 1930-х, когда здесь работали первые джаз-оркестры. В послевоенные годы джаз стал маркером интеллигентной культуры. Джазовая Филармония основана в 1979 году — первая в СССР. Сегодня в городе десятки джазовых клубов и площадок.",
        "list": [
          "1930-е: первые джаз-оркестры",
          "1960-70-е: джаз как знак интеллигентности",
          "1979: Джазовая Филармония — первая в СССР",
          "Сегодня: развитая сцена, молодые музыканты"
        ]
      },
      {
        "heading": "Джаз в ресторане «Паруса»",
        "body": "«Паруса на крыше» (ул. Марата, 5) приглашают джазовых музыкантов по расписанию. Это не джаз-клуб — это ресторан, где живая музыка органично вписана в атмосферу. Панорама Петербурга, авторская кухня, джаз — формат для тех, кто ценит культурный контекст в еде. Рейтинг 5,0. Проверяйте <a href='/afisha' class='underline text-accent'>афишу</a>."
      }
    ],
    "cta": { "text": "Забронировать джазовый вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "uzhin-zhivaya-muzyka-peterburg-restoran",
    "title": "Ужин с живой музыкой в ресторане Петербурга",
    "metaTitle": "Ужин с живой музыкой в ресторане Петербурга 2026 | Паруса",
    "metaDescription": "Рестораны Петербурга с живой музыкой для ужина: атмосфера, жанры, лучшие места.",
    "keywords": "ужин живая музыка петербург, ресторан живая музыка ужин спб, живая музыка ужин петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Ужин с живой музыкой — это больше чем еда. Это вечер, который запомнится. Живой звук создаёт атмосферу, которую невозможно повторить через плейлист.",
    "sections": [
      {
        "heading": "Почему живая музыка меняет ужин",
        "body": "Живой исполнитель реагирует на настроение зала — чуть быстрее или медленнее, чуть тише или громче. Это создаёт ощущение, что вечер происходит именно для вас. Психологически это повышает удовольствие от еды и разговора — доказано исследованиями в области гастрономической психологии.",
        "list": [
          "Живой музыкант адаптируется к залу",
          "Ощущение уникальности: этот вечер не повторится",
          "Фон для разговора без заглушки",
          "Запоминается лучше, чем ужин без музыки"
        ]
      },
      {
        "heading": "«Паруса» — ужин с живой музыкой",
        "body": "В «Парусах» (ул. Марата, 5, 6 этаж) живая музыка — часть концепции с 2009 года. Пятница, суббота, праздничные дни — наиболее насыщенное расписание. Вид на Петербург + авторская кухня + живой звук = вечер, о котором рассказывают друзьям. Рейтинг 5,0. Средний чек 1 300 ₽."
      }
    ],
    "cta": { "text": "Забронировать ужин с музыкой", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "vecher-dzhaz-vino-restoran-spb",
    "title": "Вечер джаза и вина в ресторане СПб",
    "metaTitle": "Вечер джаза и вина ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Вечер джаза и вина в ресторане Санкт-Петербурга: где провести культурный вечер с живым звуком.",
    "keywords": "вечер джаза и вина спб, джаз вино ресторан петербург, культурный вечер джаз спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Джаз и вино — классическая комбинация. Медленная музыка, хорошее вино, вид на вечерний Петербург — идеальный формат для культурного вечера в городе.",
    "sections": [
      {
        "heading": "Почему джаз и вино — идеальная пара",
        "body": "Оба опыта требуют замедленного восприятия. Джаз лучше слушать внимательно. Вино лучше пить неторопливо. Оба требуют концентрации и готовности к нюансам. Тот, кто умеет наслаждаться одним, обычно умеет наслаждаться и другим. В Петербурге с его культурными традициями этот формат особенно органичен.",
        "list": [
          "Джаз и вино: оба требуют замедления",
          "Культурный формат: не просто выпить, а пережить",
          "Вид на Петербург: третий элемент для полного впечатления",
          "Пятница или суббота: лучшие дни для такого вечера"
        ]
      },
      {
        "heading": "Организовать такой вечер в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж): живой джаз по расписанию, широкая винная карта, вид на Казанский собор и крыши центра. Столик у окна при бронировании. Средний чек 1 300–1 500 ₽ с бокалом вина. Рейтинг 5,0. Читайте <a href='/afisha' class='underline text-accent'>афишу</a>."
      }
    ],
    "cta": { "text": "Забронировать джазовый вечер с вином", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "kuda-zhivaya-muzyka-pyatnitsa-spb",
    "title": "Куда пойти на живую музыку в пятницу в СПб",
    "metaTitle": "Куда пойти на живую музыку в пятницу СПб 2026 | Паруса",
    "metaDescription": "Где слушать живую музыку в пятницу вечером в Санкт-Петербурге: рестораны и клубы с живым звуком.",
    "keywords": "живая музыка пятница спб, куда пойти пятница живая музыка петербург, живой звук пятница спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Пятница — самый музыкальный день недели. Рестораны и клубы по всему Петербургу приглашают живых исполнителей именно в пятницу. Разберём, как выбрать формат под ваш вечер.",
    "sections": [
      {
        "heading": "Форматы пятничного живого звука",
        "body": "Концертные залы: Филармония, Мариинский — требуют планирования. Джаз-клубы: менее формально, живее. Рестораны с живой музыкой: совмещают ужин и музыку, более расслабленно. В пятницу все форматы работают — выбирайте по тому, хотите ли вы идти специально за музыкой или хотите совместить с хорошим ужином.",
        "list": [
          "Концертный зал: специально за музыкой",
          "Джаз-клуб: неформально, близко к музыкантам",
          "Ресторан: ужин + фоновый живой звук",
          "В пятницу всё занято — бронируйте заранее"
        ]
      },
      {
        "heading": "Пятничная живая музыка в «Парусах»",
        "body": "Пятница — один из основных дней живой музыки в «Парусах» (ул. Марата, 5). Бронируйте за 3–7 дней. Джаз, авторская музыка, вокал — расписание варьируется. Вид на Петербург + живой звук = правильная пятница. Рейтинг 5,0. Проверяйте <a href='/afisha' class='underline text-accent'>афишу</a>."
      }
    ],
    "cta": { "text": "Забронировать пятничный ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "romanticheskie-mesta-peterburg-top",
    "title": "Романтические места Петербурга: топ-список 2026",
    "metaTitle": "Романтические места Петербурга топ 2026 | Паруса на крыше",
    "metaDescription": "Самые романтичные места Санкт-Петербурга: набережные, рестораны, смотровые площадки для влюблённых.",
    "keywords": "романтические места петербург, самые романтичные места спб, романтика петербург список",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — один из самых романтичных городов мира. Каналы, белые ночи, архитектура — всё создаёт атмосферу для особого вечера. Собрали реальный топ мест.",
    "sections": [
      {
        "heading": "Топ романтических мест",
        "body": "Набережная Невы у Петропавловской крепости: закат и крепость в одном кадре. Мост через канал Грибоедова у Спаса-на-Крови: разноцветная мозаика собора и вода — невозможно не сфотографироваться. Стрелка Васильевского острова: ночью — огни, мосты, Нева. «Паруса на крыше» (ул. Марата, 5, 6 этаж): панорамный ужин над городом — кульминация романтического дня.",
        "list": [
          "Набережная Невы: закаты, мосты, простор",
          "Мост у Спаса-на-Крови: самое фотогеничное место",
          "Стрелка В. О.: ночные огни, разводные мосты",
          "«Паруса»: ужин с панорамой — вершина романтического вечера"
        ]
      },
      {
        "heading": "Почему «Паруса» в списке романтических мест",
        "body": "Романтика — это когда место само говорит «что-то особенное происходит сейчас». С высоты 6-го этажа, с видом на купола и горизонт, за хорошим ужином и живой музыкой — это именно такой момент. Рейтинг 5,0, работает с 2009 года. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать романтическое место", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "peterburg-dlya-vlyublennykh-idei",
    "title": "Петербург для влюблённых: идеи для пары",
    "metaTitle": "Петербург для влюблённых — идеи 2026 | Паруса на крыше",
    "metaDescription": "Идеи для влюблённой пары в Петербурге: романтические прогулки, рестораны, особые моменты.",
    "keywords": "петербург для влюблённых, романтика в петербурге идеи, петербург для пары идеи",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург создан для влюблённых. Архитектура, каналы, белые ночи — всё работает на романтику. Собрали самые честные идеи для пары.",
    "sections": [
      {
        "heading": "Что делать влюблённым в Петербурге",
        "body": "Прогулка по набережной в белые ночи. Посещение Эрмитажа вместе (выбрать 2–3 любимых зала). Кофе в specialty-кофейне на Рубинштейна. Прогулка на частном кораблике по каналам. Ужин с видом на Петербург. Посмотреть разводные мосты ночью. Позавтракать с видом на просыпающийся город.",
        "list": [
          "Ночная прогулка: белые ночи — идеальный контекст",
          "Кораблик по каналам: неожиданно романтично",
          "Ужин с панорамой: кульминация дня",
          "Завтрак с видом: начать утро по-особенному"
        ]
      },
      {
        "heading": "«Паруса» как точка притяжения для пары",
        "body": "«Паруса на крыше» (ул. Марата, 5) собирают пары по особым поводам и просто так — потому что хочется вечера, который запомнится. Столик у окна с видом на закатный Петербург, авторская кухня, живая музыка. Рейтинг 5,0. Скидка 20% именинникам — если один из пары именинник.",
        "highlight": "Если хотите сделать предложение — предупредите менеджера заранее. В «Парусах» это отработано: шампанское, цветы, правильный момент. +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать вечер для пары", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "gde-sdelat-predlozhenie-v-peterburge",
    "title": "Где сделать предложение в Петербурге: идеи",
    "metaTitle": "Где сделать предложение в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Лучшие места для предложения руки и сердца в Санкт-Петербурге: рестораны, набережные, особые локации.",
    "keywords": "где сделать предложение петербург, предложение руки сердца петербург, место для предложения спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Предложение руки и сердца — момент, который должен быть идеальным. В Петербурге с его архитектурой и атмосферой правильное место само работает на вас.",
    "sections": [
      {
        "heading": "Как выбрать место для предложения",
        "body": "Правило одно: место должно говорить что-то вашей паре, а не быть «самым популярным». Тем не менее несколько точек в Петербурге работают безотказно: панорамные виды с высоты, набережная в белые ночи, красивые мосты. Главное: выбрать место, где вы не будете торопиться и где будет хотя бы несколько минут тишины.",
        "list": [
          "Панорамный ресторан: приватно, красиво, организованно",
          "Набережная в белые ночи: атмосфера, но публично",
          "Крыши: романтично, требует планирования",
          "Кораблик по каналам: уединённо, движение"
        ]
      },
      {
        "heading": "Предложение в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) — одно из лучших мест для предложения в Петербурге. Закрытый зал, столик у окна с видом на купол Казанского собора, живая музыка, менеджер который поможет с организацией (шампанское, цветы, момент). Предупредите при бронировании: +7 (812) 991-10-90.",
        "highlight": "Рекомендуем: попросите официанта принести шампанское в нужный момент. Кольцо на дне бокала — классика, которая всегда работает. Главное предупредить заранее."
      }
    ],
    "cta": { "text": "Организовать предложение в «Парусах»", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "romanticheskaya-progulka-peterburg-plan",
    "title": "Романтическая прогулка по Петербургу: маршрут",
    "metaTitle": "Романтическая прогулка Петербург — маршрут 2026 | Паруса",
    "metaDescription": "Маршрут романтической прогулки по Санкт-Петербургу: набережные, мосты, рестораны для пары.",
    "keywords": "романтическая прогулка петербург, маршрут для двоих петербург, прогулка вдвоём петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Прогулка по Петербургу вдвоём — это маршрут, который создаёт историю. Несколько часов по правильному маршруту — и вечер становится воспоминанием на годы.",
    "sections": [
      {
        "heading": "Маршрут романтической прогулки",
        "body": "Начало: Спас-на-Крови и мост через канал Грибоедова (30 минут, фото). Далее: набережная канала Грибоедова до Невского (20 минут). Казанский собор: войти внутрь, ощутить масштаб (20 минут). Невский до Аничкова моста: прогулка по главной улице (30 минут). Набережная Фонтанки вниз до улицы Марата (20 минут). Финал: подъём в «Паруса» на 6-й этаж, ужин с видом на весь пройденный маршрут.",
        "list": [
          "Спас-на-Крови: самое красивое место для фото",
          "Казанский собор: масштаб и история",
          "Невский + Аничков мост: классика",
          "«Паруса»: финал — ужин с видом сверху"
        ]
      },
      {
        "heading": "Время маршрута",
        "body": "Весь маршрут: 2,5–3 часа пешком + ужин 1,5–2 часа. Итого: 4–5 часов. Рекомендуем начинать за 3–4 часа до заката — так финальный ужин совпадёт с закатным часом. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать финальный ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "belye-nochi-peterburg-romantika",
    "title": "Белые ночи в Петербурге: романтика и что делать",
    "metaTitle": "Белые ночи Петербург — романтика 2026 | Паруса на крыше",
    "metaDescription": "Белые ночи в Санкт-Петербурге: когда бывают, что делать, лучшие романтические места.",
    "keywords": "белые ночи петербург романтика, белые ночи петербург что делать, белые ночи спб пара",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "Белые ночи — главный природный феномен Петербурга. С конца мая по середину июля солнце не заходит полностью: небо светлое всю ночь. Для романтики это уникальный контекст — ночь без темноты.",
    "sections": [
      {
        "heading": "Когда белые ночи в Петербурге",
        "body": "Период белых ночей: примерно с 25 мая по 15 июля. Самые светлые: вокруг дня летнего солнцестояния (21 июня). В этот период: закат — около 23:00, рассвет — около 03:30. Небо никогда не темнеет полностью — сохраняет нежно-синюю подсветку. Разводные мосты разводятся при светлом небе в 01:15.",
        "list": [
          "25 мая–15 июля: основной период белых ночей",
          "21 июня: самая светлая ночь в году",
          "Закат: ~23:00, рассвет: ~03:30",
          "Мосты разводятся при светлом небе — уникальное зрелище"
        ]
      },
      {
        "heading": "Романтика белых ночей",
        "body": "Белые ночи создают уникальное ощущение: гулять в 23:00 при дневном свете — это немного нереально, как сон. Для пары это особое время: набережная Невы, Петропавловская крепость на фоне светлого неба, разводные мосты в час ночи. «Паруса на крыше» (ул. Марата, 5) в белые ночи: ужин в 22:00 при дневном свете за окном — необычно и красиво.",
        "highlight": "В белые ночи приходите на ужин позже обычного: 20:00–21:00 — максимально красивый свет за окном. Золотой час без заката."
      },
      {
        "heading": "Программа для пары в белые ночи",
        "body": "19:00 — ужин в «Парусах» с видом на светлое небо. 22:00 — прогулка по набережной (ночью, но светло). 01:00 — к Дворцовому мосту на разводку. 03:30 — рассвет над Невой. Лучший вечер в году. Читайте о <a href='/blog/gde-vstretit-belye-nochi-peterburg' class='underline text-accent'>белых ночах</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин в белые ночи", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "peterbug-dlya-dvoyh-chto-sdelat",
    "title": "Петербург для двоих: что сделать и куда пойти",
    "metaTitle": "Петербург для двоих — что делать 2026 | Паруса на крыше",
    "metaDescription": "Петербург для двоих: лучшие места и идеи для пары — от прогулок до ужина с видом.",
    "keywords": "петербург для двоих что делать, куда пойти в петербурге для двоих, идеи петербург вдвоём",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — город, созданный для двоих. Архитектурные дворики, тихие набережные, рестораны с видом — всё располагает к вечерам в хорошей компании. Собрали лучшие идеи.",
    "sections": [
      {
        "heading": "Идеи для дня на двоих",
        "body": "Утро: завтрак с видом на город. День: один музей вместе (Эрмитаж или Фаберже), прогулка по каналам, кофе и эклер в кондитерской Nevsky Pastry. Вечер: ужин с видом на Петербург. После: прогулка к набережной. Программа насыщена, но не изматывает — всё в 30 минутах пешком друг от друга.",
        "list": [
          "Завтрак с видом: старт дня",
          "Один музей хорошо: не перегружайте",
          "Кафе в историческом здании: атмосфера",
          "Ужин с видом: «Паруса», ул. Марата 5"
        ]
      },
      {
        "heading": "«Паруса» как кульминация вечера",
        "body": "Ужин в «Парусах» (ул. Марата, 5, 6 этаж) — стандартная кульминация любого хорошего дня в Петербурге для пары. Столик у окна, вид на Казанский собор, живая музыка. Рейтинг 5,0. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать вечер для двоих", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "idei-svidanie-restoran-spb",
    "title": "Идеи для свидания в ресторане СПб: нестандартно",
    "metaTitle": "Идеи для свидания ресторан СПб 2026 | Паруса на крыше",
    "metaDescription": "Нестандартные идеи для романтического свидания в ресторане Санкт-Петербурга: форматы, места.",
    "keywords": "идеи свидание ресторан спб, нестандартное свидание петербург, романтическое свидание ресторан",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "«Просто пойти в ресторан» — это хорошо. Но несколько деталей превращают обычное свидание в нечто запоминающееся. Делимся идеями.",
    "sections": [
      {
        "heading": "Нестандартные форматы свидания",
        "body": "Дегустационный ужин с парингом вин: образовательно и вкусно. Завтрак в панорамном ресторане вместо ужина — неожиданно. Ужин после театра или выставки — культурный контекст. Мастер-класс по коктейлям или вину + ужин. Арендовать приватную зону в ресторане для ужина только вдвоём.",
        "list": [
          "Дегустация с парингом: 2 часа, несколько блюд и вин",
          "Завтрак вместо ужина: нестандартно, запоминается",
          "После театра: культурный контекст",
          "Приватная зона: «только мы двое»"
        ]
      },
      {
        "heading": "Первое свидание vs повторное",
        "body": "Первое свидание: место должно быть достаточно красивым, чтобы работать само по себе. «Паруса» — хороший выбор: вид производит впечатление без усилий. Повторное свидание: можно экспериментировать — дегустация, тематический вечер, другой ресторан. В «Парусах» (ул. Марата, 5) достаточно вариантов для обоих. Читайте о <a href='/blog/pervoe-svidanie-restoran-peterburg' class='underline text-accent'>первом свидании</a>."
      }
    ],
    "cta": { "text": "Забронировать свидание", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "kuda-povesti-devushku-peterburg",
    "title": "Куда повести девушку в Петербурге: идеи",
    "metaTitle": "Куда повести девушку в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Куда повести девушку в Санкт-Петербурге: рестораны, прогулки, нестандартные идеи для впечатления.",
    "keywords": "куда повести девушку в петербурге, место для девушки петербург, куда сводить девушку спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Правильное место — половина успеха свидания. В Петербурге масса опций, но выбрать то, что действительно произведёт впечатление — требует понимания города.",
    "sections": [
      {
        "heading": "Что производит впечатление",
        "body": "Место с «вау-эффектом» при входе: вид, интерьер, атмосфера — всё должно говорить «это нечто особенное». Ненавязчивость: не слишком пышно и официально. Хорошая еда: это сигнал, что вы позаботились о деталях. Уединённость: не слишком шумно и людно. «Паруса на крыше» (ул. Марата, 5, 6 этаж) соответствуют всем четырём критериям.",
        "list": [
          "«Вау» при входе: вид с 6-го этажа работает безотказно",
          "Ненавязчивость: не пафосно, но явно особенное",
          "Хорошая кухня: авторское меню",
          "Уютная атмосфера: не слишком людно и шумно"
        ]
      },
      {
        "heading": "Программа вечера с «Парусами»",
        "body": "Прогулка по центру (Невский, Казанский, канал Грибоедова) → «Паруса» на ул. Марата, 5. Ужин с видом на вечерний Петербург. Живая музыка. После — прогулка к набережной. Средний чек ~1 300 ₽/человек. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "restoran-posle-spektaklya-mariinski",
    "title": "Ресторан после спектакля в Мариинском театре СПб",
    "metaTitle": "Ресторан после Мариинского театра СПб 2026 | Паруса на крыше",
    "metaDescription": "Где поесть после спектакля в Мариинском театре в Петербурге: рестораны в 15 минутах.",
    "keywords": "ресторан после мариинского театра, где поесть после мариинского спб, ужин после оперы петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "После оперы или балета в Мариинском хочется продолжить вечер — за хорошим ужином и с впечатлениями от спектакля. Выбор правильного ресторана — последний штрих культурного вечера.",
    "sections": [
      {
        "heading": "Рестораны после Мариинского",
        "body": "Мариинский театр — Коломна, Театральная площадь. Ближайшие рестораны: в радиусе 500 метров — несколько вариантов у набережной Мойки. Для более высокого уровня — 15 минут на такси до центра. «Паруса» (ул. Марата, 5) — 15 минут, уровень выше любого заведения прямо у Мариинского.",
        "list": [
          "Рядом с Мариинским: ограниченный выбор",
          "Набережная Мойки: атмосферно, 10–15 минут",
          "«Паруса»: 15 минут, другой уровень впечатлений",
          "Спектакль заканчивается 21:00–22:00 — идеальное время для ужина"
        ]
      },
      {
        "heading": "Культурный вечер в два акта",
        "body": "Мариинский + ужин в «Парусах» — это культурный вечер на два акта. Первый: опера или балет. Второй: панорама города, авторская кухня, живая музыка. Оба акта петербургские по духу. Рейтинг 5,0. Средний чек 1 300 ₽. Бронируйте ужин одновременно с театральными билетами.",
        "highlight": "Если вы в Петербурге один вечер: Мариинский + «Паруса» — лучшая комбинация культуры и гастрономии."
      }
    ],
    "cta": { "text": "Забронировать ужин после театра", "href": "/" }
  },
  {
    "slug": "uzhin-posle-ermitazha-peterburg",
    "title": "Ужин после Эрмитажа в Петербурге: где поесть",
    "metaTitle": "Ужин после Эрмитажа Петербург 2026 | Паруса на крыше",
    "metaDescription": "Где поужинать после Эрмитажа в Санкт-Петербурге: рестораны в 10–20 минутах, обзор мест.",
    "keywords": "ужин после эрмитажа, где поесть после эрмитажа петербург, ресторан рядом с эрмитажем спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "После нескольких часов в Эрмитаже хочется есть, выдохнуть и переосмыслить увиденное. Правильный ужин продолжает культурный опыт.",
    "sections": [
      {
        "heading": "Рестораны после Эрмитажа",
        "body": "Эрмитаж — на Дворцовой набережной. В радиусе 500 метров: туристические рестораны у Дворцовой площади (дорого, средне по кухне). Лучший вариант: уйти на 15–20 минут пешком. Невский проспект (10 минут): широкий выбор. Улица Марата (20 минут пешком): лучший ресторанный квартал. «Паруса» — ул. Марата, 5, 6 этаж.",
        "list": [
          "У Дворцовой: туристически, дорого",
          "Невский: 10 минут, разнообразно",
          "Улица Марата: 20 минут, лучшее соотношение цена/качество",
          "«Паруса»: вид на весь центр, авторская кухня"
        ]
      },
      {
        "heading": "Почему «Паруса» после Эрмитажа — хорошая идея",
        "body": "После Эрмитажа голова полна образами — архитектурой, искусством, историей. «Паруса» (ул. Марата, 5, 6 этаж) дают другой ракурс на город: сверху, в 300° панораме. Это помогает «собрать» увиденное за день. Авторская кухня, рейтинг 5,0. Читайте о <a href='/blog/gde-poyest-posle-ermitazha-spb' class='underline text-accent'>ресторанах после Эрмитажа</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин после Эрмитажа", "href": "/" }
  },
  {
    "slug": "kulturnyy-vecher-muzyka-eda-spb",
    "title": "Культурный вечер с музыкой и едой в СПб",
    "metaTitle": "Культурный вечер музыка и еда СПб 2026 | Паруса на крыше",
    "metaDescription": "Культурный вечер с живой музыкой и хорошей едой в Санкт-Петербурге: рестораны и форматы.",
    "keywords": "культурный вечер музыка еда спб, ужин культура живая музыка петербург, культурный ужин спб",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Культурный вечер — это когда искусство и гастрономия встречаются в одном пространстве. В Петербурге таких мест несколько, и «Паруса на крыше» — одно из них.",
    "sections": [
      {
        "heading": "Что такое культурный гастрономический вечер",
        "body": "Формат: ужин в ресторане с живой музыкой или после посещения культурного учреждения (театр, выставка, музей). Идея: искусство создаёт эмоциональный фон, гастрономия — физический комфорт. Вместе они создают целостный опыт вечера, который запоминается как единое событие.",
        "list": [
          "Театр + ужин: два акта одного культурного вечера",
          "Выставка + ужин с художественной программой",
          "Ресторан с живой музыкой: встроенная культура",
          "Дегустация вин с историческим рассказом"
        ]
      },
      {
        "heading": "«Паруса» как культурное пространство",
        "body": "«Паруса» (ул. Марата, 5) — больше чем ресторан. Это живая музыка по расписанию, вид на архитектурные доминанты Петербурга, авторская кухня. Всё вместе создаёт культурное пространство, в котором вечер становится событием. Рейтинг 5,0, «Хорошее место 2026». Читайте о <a href='/afisha' class='underline text-accent'>программе ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать культурный вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "gastronomicheskiy-turizm-peterburg",
    "title": "Гастрономический туризм в Петербурге: гид 2026",
    "metaTitle": "Гастрономический туризм Петербург 2026 | Паруса на крыше",
    "metaDescription": "Гастрономический туризм в Санкт-Петербурге: рестораны, рынки, гастро-маршруты для гурманов.",
    "keywords": "гастрономический туризм петербург, гастро туризм спб, кулинарный туризм петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Гастрономический туризм — поездка ради кухни. Петербург заслуживает отдельного гастро-трипа: здесь сильная ресторанная сцена, уникальные локальные продукты и сложившаяся культура вкуса.",
    "sections": [
      {
        "heading": "Что делает Петербург гастро-городом",
        "body": "Исторически Петербург — столица, где концентрировались лучшие повара и продукты. Близость к Финскому заливу и Карелии — свежая рыба, ягоды. Петербургская интеллигенция всегда ценила кухню. Сегодня: активная ресторанная сцена, несколько ресторанов мирового уровня, крафтовые производители, рынки.",
        "list": [
          "Корюшка: петербургский деликатес апреля–мая",
          "Карельская рыба и ягоды: свежие и уникальные",
          "Ресторанная сцена: активно растёт с 2010-х",
          "Кофейная культура: одна из лучших в России"
        ]
      },
      {
        "heading": "Гастро-маршрут для туриста",
        "body": "День 1: Некрасовский рынок (фермерские продукты), обед в ресторане с локальными ингредиентами, ужин в «Парусах» (авторская кухня + вид). День 2: specialty-кофе, Эрмитаж + обед рядом, ужин в другом ресторане центра. День 3: корюшка в сезон, прогулка с едой. В «Парусах» (ул. Марата, 5, 6 этаж) авторская кухня — обязательная точка гастро-трипа. Рейтинг 5,0.",
        "highlight": "Совет гастро-туриста: приезжайте в апреле–мае — сезон корюшки. Эта маленькая рыбка с запахом огурца — символ петербургской весны."
      }
    ],
    "cta": { "text": "Забронировать гастро-ужин", "href": "/" }
  },
  {
    "slug": "artvecheri-restoran-peterburg",
    "title": "Арт-вечер в ресторане Петербурга: форматы",
    "metaTitle": "Арт-вечер в ресторане Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Арт-вечера в ресторанах Санкт-Петербурга: ужин с художниками, поэзия, живопись и еда.",
    "keywords": "арт вечер ресторан петербург, арт ужин спб, искусство еда ресторан петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Арт-вечер в ресторане — когда изобразительное искусство или поэзия встречаются с гастрономией. Нестандартный формат для тех, кто хочет выйти за рамки обычного ужина.",
    "sections": [
      {
        "heading": "Форматы арт-вечеров",
        "body": "Ужин с живописью: художник рисует прямо в зале, гости наблюдают. Арт-объекты в интерьере: выставка работ местных художников как постоянный фон. Поэтический вечер: поэт читает стихи между переменами блюд. Музыкальный арт-вечер: джаз + визуальное искусство как единая инсталляция.",
        "list": [
          "Живопись в процессе: художник рисует при гостях",
          "Выставка в зале: произведения как часть интерьера",
          "Поэтический вечер: слово как десерт",
          "Музыкально-визуальный синтез"
        ]
      },
      {
        "heading": "Арт-программа в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5) периодически проводят специальные программы с культурной составляющей. Следите за анонсами в афише или уточняйте при бронировании: +7 (812) 991-10-90. Рейтинг 5,0, «Хорошее место 2026». Читайте <a href='/afisha' class='underline text-accent'>актуальные мероприятия</a>."
      }
    ],
    "cta": { "text": "Забронировать культурный вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "zakaty-peterburg-luchshie-tochki",
    "title": "Закат над Петербургом: лучшие точки для наблюдения",
    "metaTitle": "Закат над Петербургом — лучшие точки 2026 | Паруса на крыше",
    "metaDescription": "Где наблюдать закат над Санкт-Петербургом: смотровые точки, рестораны, набережные.",
    "keywords": "закат петербург где смотреть, закат над петербургом точки, наблюдать закат петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Закат над Петербургом — зрелище, от которого сложно оторваться. Золотые купола в красном свете, горизонт над городом — это эстетика, которую не забудешь.",
    "sections": [
      {
        "heading": "Лучшие точки для заката",
        "body": "Исаакиевский собор (колоннада): 360° вид, закат прямо на запад. Финский залив: горизонт, солнце уходит в воду. «Паруса» (ул. Марата, 5, 6 этаж): закат за ужином — золотой свет освещает зал и купола снаружи. Стрелка Васильевского острова: закат по Малой Неве.",
        "list": [
          "Исаакий (колоннада): 360°, лучшая наземная точка",
          "«Паруса»: закат + ужин = идеальный вечер",
          "Финский залив: природный горизонт",
          "Стрелка В. О.: вода и силуэт города"
        ]
      },
      {
        "heading": "Закат в «Парусах»",
        "body": "Западная ориентация окон «Парусов» (ул. Марата, 5, 6 этаж) — специально для закатных ужинов. Золотой час: купол Казанского собора в красном свете. Это происходит каждый вечер, и каждый вечер немного иначе. Рейтинг 5,0. Читайте о <a href='/blog/gde-vstretit-zakat-restoran-spb-leto' class='underline text-accent'>встрече заката в ресторане</a>."
      }
    ],
    "cta": { "text": "Забронировать закатный ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "nezabyvaemyy-vecher-peterburg-kak",
    "title": "Незабываемый вечер в Петербурге: как устроить",
    "metaTitle": "Незабываемый вечер в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Как устроить незабываемый вечер в Петербурге: пошаговый план для особого события.",
    "keywords": "незабываемый вечер петербург, особый вечер петербург как, лучший вечер в петербурге",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Незабываемый вечер — это не случайность. Это результат нескольких правильных решений: место, время, компания и финальный штрих. Расскажем, как это сделать в Петербурге.",
    "sections": [
      {
        "heading": "Что делает вечер незабываемым",
        "body": "Три компонента: новизна (место или формат, которого раньше не было), эмоциональный пик (момент восторга — вид, музыка, вкус), разговор (хорошие вечера — это люди и слова, а не только атмосфера). Петербург даёт первые два легко. Третье — вы создаёте сами.",
        "list": [
          "Новизна: место, в котором вы никогда не бывали",
          "Эмоциональный пик: вид, музыка, вкус",
          "Разговор: хороший вечер — это люди",
          "Финальный штрих: что-то неожиданное"
        ]
      },
      {
        "heading": "Пошаговый план незабываемого вечера",
        "body": "1. Прогулка по набережной или каналам. 2. Подъём в «Паруса» (ул. Марата, 5, 6 этаж) — первый взгляд на панораму создаёт «вау». 3. Ужин с авторской кухней и живой музыкой. 4. После: прогулка к набережной Невы. В июне — встреча рассвета. Рейтинг 5,0, средний чек 1 300 ₽. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать незабываемый вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "peterbug-v-noyabre-romanticheskie-idei",
    "title": "Петербург в ноябре: романтические идеи для пары",
    "metaTitle": "Петербург в ноябре — романтические идеи 2026 | Паруса",
    "metaDescription": "Ноябрьский Петербург: романтические идеи для пары — куда пойти в самый серый месяц.",
    "keywords": "петербург ноябрь романтика, ноябрь петербург куда пойти, петербург ноябрь пара идеи",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Ноябрь в Петербурге — самый петербургский месяц. Серое небо, туман, холодный ветер — и невероятная атмосфера. Именно в ноябре город открывается как «тот самый Петербург» Достоевского.",
    "sections": [
      {
        "heading": "Ноябрь: особая эстетика города",
        "body": "Ноябрьский Петербург в туристическом плане — низкий сезон. Но для тех, кто понимает: это лучшее время. В музеях тихо. Ресторан доступен без брони за месяц. Город выглядит как чёрно-белая фотография с акцентами огней — подсветка соборов, фонари, ночные кафе. Это меланхоличная красота.",
        "list": [
          "В музеях почти нет людей — можно стоять у картин сколько угодно",
          "Рестораны в ноябре: лучшая доступность года",
          "Серый город + тёплый ресторан = правильный контраст",
          "Цены: на 15–20% ниже летних"
        ]
      },
      {
        "heading": "Ноябрьский ужин в «Парусах»",
        "body": "В ноябре «Паруса» (ул. Марата, 5) особенно атмосферны: тёплый зал, огни ночного города за панорамными окнами, живая музыка. Тёплый уют внутри против холодного ноября снаружи — правильный контраст для романтического вечера. Рейтинг 5,0. Читайте о <a href='/blog/zimniy-restoran-uyutnyy-peterburg' class='underline text-accent'>зимних уютных ресторанах</a>."
      }
    ],
    "cta": { "text": "Забронировать ноябрьский ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "peterburg-molodozhenov-kuda-poyti",
    "title": "Петербург для молодожёнов: куда пойти после свадьбы",
    "metaTitle": "Петербург для молодожёнов 2026 | Паруса на крыше",
    "metaDescription": "Куда пойти молодожёнам в Петербурге: рестораны, прогулки, незабываемые места для первых дней вместе.",
    "keywords": "петербург для молодожёнов, медовый месяц петербург, молодожёны петербург куда",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — один из лучших городов России для медового месяца или первых дней после свадьбы. Красота, рестораны, романтические прогулки — всё создано для молодожёнов.",
    "sections": [
      {
        "heading": "Петербург для медового месяца",
        "body": "Две ночи в Петербурге + несколько правильных мест = воспоминания на всю жизнь. Маршрут: день 1 — исторический центр + ужин с видом. День 2 — острова, прогулка, кораблик по каналам, второй ужин в другом ресторане. Петербург компактен: всё в пешей доступности, не нужны экскурсионные автобусы.",
        "list": [
          "День 1: Эрмитаж + ужин в «Парусах»",
          "День 2: острова + кораблик + ужин у воды",
          "Белые ночи в июне: идеально для свадебного путешествия",
          "Компактность: весь центр пешком"
        ]
      },
      {
        "heading": "«Паруса» для молодожёнов",
        "body": "«Паруса» (ул. Марата, 5, 6 этаж) — один из лучших ресторанов для первого совместного ужина после свадьбы. Столик у окна, шампанское, вид на город. Скидка 20% именинникам действует и для пар, если у кого-то день рождения в это время. Рейтинг 5,0. Читайте о <a href='/svadba' class='underline text-accent'>свадебных возможностях ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин для молодожёнов", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "iskusstvo-i-gastronomiya-peterburg",
    "title": "Искусство и гастрономия в Петербурге: синтез",
    "metaTitle": "Искусство и гастрономия Петербург 2026 | Паруса на крыше",
    "metaDescription": "Как искусство и еда сочетаются в Петербурге: рестораны с культурной программой, галереи с едой.",
    "keywords": "искусство гастрономия петербург, арт гастрономия спб, культура и еда петербург",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Петербург — один из немногих российских городов, где искусство и гастрономия действительно работают вместе. Это не маркетинговое решение, а культурная традиция.",
    "sections": [
      {
        "heading": "Где пересекаются искусство и еда в Петербурге",
        "body": "Рестораны с арт-программой: живая музыка, выставки, поэтические вечера. Галереи с едой: «Эрарта» (современное искусство) имеет ресторан. Лофт Проект «Этажи»: галерея + кафе. «Новая Голландия»: культурное пространство с едой летом. Это разные форматы одного явления: искусство создаёт контекст для еды.",
        "list": [
          "«Эрарта»: музей + ресторан",
          "«Новая Голландия»: парк + галереи + еда летом",
          "Лофт Проект «Этажи»: галерея + кафе + вид с крыши",
          "Рестораны с живой музыкой: встроенное искусство"
        ]
      },
      {
        "heading": "«Паруса» как пример синтеза",
        "body": "«Паруса на крыше» (ул. Марата, 5) сочетают городскую архитектуру (искусство вокруг вас — Казанский собор, крыши) с авторской кухней (гастрономия как искусство) и живой музыкой (исполнительное искусство). Это непрограммный, ненарочитый синтез. Рейтинг 5,0, «Хорошее место 2026»."
      }
    ],
    "cta": { "text": "Забронировать культурный ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "fotooprog-nochnoy-peterburg-para",
    "title": "Фотопрогулка по ночному Петербургу для пары",
    "metaTitle": "Фотопрогулка ночной Петербург для пары 2026 | Паруса",
    "metaDescription": "Маршрут ночной фотопрогулки по Петербургу для пары: лучшие точки и как совместить с ужином.",
    "keywords": "фотопрогулка ночной петербург, ночная фотосессия петербург, ночная прогулка фото петербург пара",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Ночной Петербург — фотографический рай. Подсветка, отражения в воде, пустые улицы в 2 часа ночи — виды, которых не бывает днём. Расскажем, как спланировать ночную фотопрогулку для пары.",
    "sections": [
      {
        "heading": "Маршрут ночной фотопрогулки",
        "body": "22:00 — ужин в «Парусах» (ул. Марата, 5), фото через панорамные окна. 23:30 — выход на прогулку: Казанский собор (подсветка), набережная канала Грибоедова (отражения у Спаса-на-Крови). 01:00 — Дворцовая площадь (подсветка Зимнего дворца). 01:15 — Дворцовый мост (разводка). 02:00 — Биржевая площадь (Ростральные колонны в огне). 03:30 — рассвет у Петропавловской.",
        "list": [
          "Спас-на-Крови ночью: отражения в канале — лучший кадр",
          "Зимний дворец: подсветка превращает фасад в театральный",
          "Разводные мосты: уникальное зрелище с хорошей камерой",
          "Рассвет: 03:30–04:30 в июне — нежно-розовое небо"
        ]
      },
      {
        "heading": "Начать с ужина",
        "body": "Начало маршрута — ужин в «Парусах». Помимо еды, с 6-го этажа можно сделать несколько хороших кадров через панорамные окна. Закат + вечер + ночной город = три разных света за один вечер. Рейтинг 5,0. Читайте о <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтическом ужине</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин перед прогулкой", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "kuda-povesti-devushku-vpervye-peterburg",
    "title": "Куда повести девушку в Петербурге впервые",
    "metaTitle": "Куда повести девушку в Петербурге впервые 2026 | Паруса",
    "metaDescription": "Куда повести девушку в Петербурге в первый раз: маршрут, места и рестораны для первого впечатления.",
    "keywords": "куда повести девушку первый раз петербург, первое свидание петербург, куда сводить девушку спб впервые",
    "date": "2026-06-06",
    "category": "Лайфстайл",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Первый раз в Петербурге — это одно впечатление. Первый раз вдвоём с девушкой в Петербурге — другое. Расскажем, как сделать этот день идеальным.",
    "sections": [
      {
        "heading": "Маршрут первого дня вдвоём",
        "body": "Утро: кофе в кофейне рядом с отелем. День: прогулка от Казанского собора по набережной до Дворцовой, один музей (Эрмитаж или Фаберже). Вечер: ужин в «Парусах» (ул. Марата, 5) — вид произведёт впечатление. После: прогулка к Неве. Белые ночи: к мостам. Всё — в пешей доступности. Всё — красиво.",
        "list": [
          "Казанский + набережная: начало маршрута",
          "Эрмитаж: один музей, не несколько",
          "«Паруса» для ужина: вид создаёт «вау»",
          "После: прогулка + мосты в июне"
        ]
      },
      {
        "heading": "Почему «Паруса» — правильный выбор",
        "body": "Первое впечатление от вида с 6-го этажа — это именно «вау». Она не была здесь раньше. Панорама, живая музыка, авторская кухня — это место говорит само за себя. Вам не нужно ничего объяснять: просто открыть дверь лифта. Рейтинг 5,0. Средний чек 1 300 ₽/чел."
      }
    ],
    "cta": { "text": "Забронировать первое совместное свидание", "href": "/romanticheskiy-uzhin" }
  }
];
